module.exports = __webpack_public_path__ + "img/pd-img-face2.f2b66b9a.png";